module.exports = __webpack_public_path__ + "img/know.3829e093.png";